/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, lazy } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import { AddWrapper } from '../modules/inquiry-management/add/AddWrapper'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  const WalkInInquiry = lazy(() => import('../modules/inquiry-management/QrMainPage'))

  const authUser = currentUser?.user;
  let routeElements;

  if (authUser && authUser.roles && authUser.roles.length > 0) {
    const slugs = authUser.roles[0].slug;
    if (slugs === 'VisaExecutive' || slugs === 'VisaFileTeam') {
      routeElements = (
        <Route index element={<Navigate to='/visadashboard' />} />
      );
    }
    else if (slugs === 'Client') {
      routeElements = (
        <Route index element={<Navigate to={`/visafile-management/edit/${authUser.id}`} />} />
      );
    }
    else {
      routeElements = (
        <Route index element={<Navigate to='/dashboard' />} />
      );
    }
  }


  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {routeElements}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
              <Route path='walkininquiry-management/*' element={<WalkInInquiry string={'WalkInInqWithQr'} ModuleName={{ singular: 'inquiry basic', plural: 'inquirybasics', slug: 'inquirybasic' }} />} />
              {/* <Route path='walkininquiry' element={<AddWrapper string={'WalkInInqWithQr'} ModuleName={{ singular: 'inquiry basic', plural: 'inquirybasics', slug: 'inquirybasic' }} />} /> */}


            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
